const ITEMS = ["Websites that sell", "AI chatbots", "WhatsApp automation", "Local SEO", "AEO for AI search", "CRM pipelines", "Meta Ads", "RPA workflows"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative overflow-hidden border-y border-white/10 bg-[#0B111F] py-8" data-testid="marquee-section" aria-label="What we do">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-display text-4xl font-bold tracking-tight sm:text-6xl">
            <span className={i % 2 ? "text-outline" : "text-white"}>{t}</span>
            <svg viewBox="0 0 32 32" className="h-7 w-7 shrink-0 sm:h-9 sm:w-9"><rect x="9" y="9" width="14" height="14" rx="3" transform="rotate(45 16 16)" fill="#00F0FF" /></svg>
          </span>
        ))}
      </div>
    </section>
  );
};
